"use strict";

exports.__esModule = true;
var _Surface = require("./Surface");
Object.keys(_Surface).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Surface[key]) return;
  exports[key] = _Surface[key];
});